import { Typography } from '@mui/material'
import React from 'react'

import { PanelBox } from '../default'
import { AccessKeysTable } from '../tables'

/**
 * @description Renders a panel for managing access keys.
 *
 * @author Isadora Botassari
 * @returns {React.Component} The rendered AccessKeysPanel component.
 */
const AccessKeysPanel = () => {

    return (
        <PanelBox>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
                Gerenciar Chaves de Acesso
            </Typography>
            <AccessKeysTable />
        </PanelBox>
    )
}

export default AccessKeysPanel